import React from 'react'
import { ImageCardMenuLeft, ImageCardMenuRight, ImageCardMenuProduct } from '../../assets'
import {
  StyledMenuCards,
  StyledLogo,
  StyledCards,
  MiniLogoContainer,
  StyledCard
} from './index.styled'
import CardMenuInitial from '../card-menu-initial'

const MenuCardsComponent = () => (
  <div className="container-fluid w-100">
    <div className="row">
      <div className="col-12 p-5">
        <StyledMenuCards>
          <StyledLogo>
            <MiniLogoContainer />
          </StyledLogo>
          <StyledCards>
            <StyledCard>
              <CardMenuInitial
                klass="description"
                image={ImageCardMenuProduct}
                title="Amorim Cork Flooring"
                textImage={ImageCardMenuLeft}
                description="Start Visit"
                delay='.2s'
              />
            </StyledCard>
            <StyledCard>
              <CardMenuInitial
                klass="description_2"
                title="Amorim Group - Business Units"
                textImage={ImageCardMenuRight}
                description="Know More"
                delay='.25s'
              />
            </StyledCard>
          </StyledCards>
        </StyledMenuCards>
      </div>
    </div>
  </div>
);

export default MenuCardsComponent;
